import { createFileRoute } from '@tanstack/react-router';
import { SocialAuthCallback } from '@/pages/SocialAuthCallback';

export const Route = createFileRoute('/_public/auth-success')({ component: SocialAuthCallback });
